import { render, staticRenderFns } from "./DailyPalletVolume.vue?vue&type=template&id=6658fd24&scoped=true&"
import script from "./DailyPalletVolume.vue?vue&type=script&lang=ts&"
export * from "./DailyPalletVolume.vue?vue&type=script&lang=ts&"
import style0 from "./DailyPalletVolume.vue?vue&type=style&index=0&id=6658fd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658fd24",
  null
  
)

export default component.exports